<template lang="pug">
  div.efx-site-footer
    div.container.c1
      div.row
        div.col-6
          div.efx-site-footer_legal-links.d-flex.justify-content-start
            ul.list-inline              
              li.list-inline-item.mr-4.mb-0 
                a(href='https://www.equifax.com/personal/accessibility-statement') Accessibility
              li.list-inline-item.mr-4.mb-0 
                a(href='https://www.equifax.com/privacy') Privacy
              li.list-inline-item.mr-4.mb-0 
                a(href='https://www.nplexle.com/terms.html') Terms of Use
        div.col-6
          div.efx-site-footer_social-media.d-flex.justify-content-end
            ul.list-inline
                li.list-inline-item
                  a(href='https://www.equifax.com/follow-us')
                    img.social-media-icon(src='../assets/img/x-twitter.svg')
                li.list-inline-item
                  a(href='https://www.equifax.com/follow-us')
                    img.social-media-icon(src='../assets/img/linkedin.svg')
                li.list-inline-item
                  a(href='https://www.equifax.com/follow-us')
                    img.social-media-icon(src='../assets/img/facebook-f.svg')
                li.list-inline-item
                  a(href='https://www.equifax.com/follow-us')
                    img.social-media-icon(src='../assets/img/youtube.svg')
                li.list-inline-item
                  a(href='https://www.equifax.com/follow-us')
                    img.social-media-icon(src='../assets/img/instagram.svg')
                li.list-inline-item
                  a(href='https://www.equifax.com/follow-us')
                    img.social-media-icon(src='../assets/img/rss.svg')

    div.container.c2
      div.row.mt-2
        div.efx-site-footer__logo.col-1.mt-3
          a(href='https://www.equifax.com/follow-us')
          img(src='../assets/img/logo_EFX_TM.png')
        div.efx-site-footer__copyright.col
          div Copyright {{ (new Date()).getFullYear() }} Equifax Inc. All rights reserved Equifax and the Equifax marks used herein are trademarks of Equifax Inc. Other product and company names mentioned herein are the property of their respective owners.
        div.efx-site-footer__tagline.col-3.d-flex.justify-content-end.mt-1
          a(href='https://www.equifax.com/follow-us')
          img.img-responsive.ml-1(src='../assets/img/english_185x10.png')
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';

.svg-nplexle {
  width: 1.5rem;
  height: 1.5rem;
}

.efx-site-footer {
    background: #333e48;
    color: #fff;
    font-family: Open Sans, Arial, sans-serif;
    font-size: .77875rem;
    min-height: 12.5rem;
}

.efx-site-footer>.container.c2 {
  border-top: 0.063rem solid #b2b2b2;
  align-items: baseline;
  display: flex;
}

.efx-site-footer__legal-links li {
    padding-left: 0;
}

.container {
    max-width: 83.125rem;
}

.container.c1 {
  height: 5rem;
  margin-top: 1rem;
  align-items: baseline;
  padding-top: 1.75rem;
}

.container.c1 .row {
  width: 100%;
}

.container.c2 {
  height: 4.875rem;
  padding-top: 0.75rem;
}

.efx-site-footer__legal-links ul.row.list-inline {
  flex-wrap: nowrap!important;
}

.efx-site-footer_social-media {
  position: relative;
  left: 1.875rem;
}

.efx-site-footer_social-media ul li.d-inline {
  margin-left: 0.75rem;
}

.efx-site-footer__logo {
    max-width: 5.125rem;
}

.efx-site-footer__copyright {
  font-weight: 400;
  font-size: .825rem;
}

.efx-site-footer__tagline {
  max-width: 21.875rem;
  line-height: 1.246rem;
}

.efx-site-footer__tagline img {
    height: 3.313rem;
    width: 20.063rem;
}

.img-responsive {
    height: auto;
    max-width: 100%;
    vertical-align: middle;
}

a {
  font-size: 1.04em !important;
  font-weight: bold;
  color: #fff;
}

.list-inline-item {
    display: inline-block;
}

.social-media-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #fff;
  background-color: transparent;
}

</style>
